import React, { useEffect, useState } from "react";
import Breadcrumb from "../../../../Components/Breadcrumb/Breadcrumb";
import axios from "axios";
import EvnVar from "../../../../EnvVar";
import Cookies from "js-cookie";
import {
  MaterialReactTable,
  createMRTColumnHelper,
  useMaterialReactTable,
} from "material-react-table";
import { Box, Button } from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { mkConfig, generateCsv, download } from "export-to-csv";

function AmbassadorsReport() {
  const baseURL = EvnVar();
  const token = Cookies.get("jwt");
  const [data, setData] = useState([]);
  const dataFirstKey = data[0];
  const reportDataKey = dataFirstKey ? Object.keys(dataFirstKey) : [];
  const [ambassadorDelete, setAmbassadorDelete] = useState(null);
  const [loading, setLoading] = useState(null);

  useEffect(() => {
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${baseURL}/user/ambassadorsReport`,
      headers: {
        Authorization: token,
      },
      withCredentials: true,
    };
    axios
      .request(config)
      .then((response) => {
        let reportData = response.data;
        reportData = reportData.map((value) => {
          const updatedValue = {
            ...value,
            delete_btn: (
              <Button
                variant="contained"
                onClick={() =>
                  value.deleted === 0
                    ? handleDelete(value.ambassador_id)
                    : handleUnDelete(value.ambassador_id)
                }
                sx={{
                  backgroundColor: value.deleted === 0 ? "red" : "green",
                  color: "white",
                  "&:hover": {
                    backgroundColor:
                      value.deleted === 0 ? "darkred" : "darkgreen",
                  },
                }}
              >
                {value.deleted === 0 ? "Delete" : "Undo"}
                {loading === value.ambassador_id && (
                  <i className="fa fa-spinner fa-spin ms-2"></i>
                )}
              </Button>
            ),
          };
          return updatedValue;
        });

        setData(reportData, null, 2);
      })
      .catch((error) => {
        console.error("Error making request:", error.message);
        if (error.response) {
          console.error("Error response data:", error.response.data);
          console.error("Error response status:", error.response.status);
          console.error("Error response headers:", error.response.headers);
        } else if (error.request) {
          console.error("Error request data:", error.request);
        } else {
          console.error("Error message:", error.message);
        }
      });
  }, [ambassadorDelete]);

  const columnHelper = createMRTColumnHelper();

  //   const newReportDataKey = [...reportDataKey, "Delete"];
  const columns = reportDataKey.map((value) => {
    return columnHelper.accessor(value, {
      header: value,
    });
  });

  const csvConfig = mkConfig({
    fieldSeparator: ",",
    decimalSeparator: ".",
    useKeysAsHeaders: true,
  });

  const handleExportRows = (rows) => {
    let rowData = rows.map((row) => row.original);
    console.log("rowDAtea ", rowData);
    const csv = generateCsv(csvConfig)(rowData);
    download(csvConfig)(csv);
  };

  const handleExportData = () => {
    console.log("data is ", data);
    const csv = generateCsv(csvConfig)(data);
    download(csvConfig)(csv);
  };

  const table = useMaterialReactTable({
    columns,
    data,
    enableRowSelection: true,
    columnFilterDisplayMode: "popover",
    paginationDisplayMode: "pages",
    positionToolbarAlertBanner: "bottom",
    initialState: {
      pagination: {
        pageSize: 5,
      },
    },
    renderTopToolbarCustomActions: ({ table }) => (
      <Box
        sx={{
          display: "flex",
          gap: "16px",
          padding: "8px",
          flexWrap: "wrap",
        }}
      >
        <Button onClick={handleExportData} startIcon={<FileDownloadIcon />}>
          Export All Data
        </Button>
        <Button
          disabled={table.getPrePaginationRowModel().rows.length === 0}
          onClick={() =>
            handleExportRows(table.getPrePaginationRowModel().rows)
          }
          startIcon={<FileDownloadIcon />}
        >
          Export All Rows
        </Button>

        <Button
          disabled={table.getRowModel().rows.length === 0}
          onClick={() => handleExportRows(table.getRowModel().rows)}
          startIcon={<FileDownloadIcon />}
        >
          Export Page Rows
        </Button>
        <Button
          disabled={
            !table.getIsSomeRowsSelected() && !table.getIsAllRowsSelected()
          }
          //only export selected rows
          onClick={() => handleExportRows(table.getSelectedRowModel().rows)}
          startIcon={<FileDownloadIcon />}
        >
          Export Selected Rows
        </Button>
      </Box>
    ),
  });

  const handleDelete = async (ambassadorId) => {
    setLoading(ambassadorId);
    setAmbassadorDelete(false);
    try {
      let config = {
        method: "put",
        maxBodyLength: Infinity,
        url: `${baseURL}/user/deleteAmbassador/${ambassadorId}`,
        headers: {
          "content-type": "application/json",
          Authorization: token,
        },
        withCredentials: true,
      };

      const response = await axios.request(config);
      if (response.status === 200) {
        setAmbassadorDelete(true);
        setLoading(null);
      }
    } catch (error) {
      console.log(error);
      setLoading(null);
    }
  };

  const handleUnDelete = async (ambassadorId) => {
    setLoading(ambassadorId);
    setAmbassadorDelete(false);
    try {
      let config = {
        method: "put",
        maxBodyLength: Infinity,
        url: `${baseURL}/user/undeleteAmbassador/${ambassadorId}`,
        headers: {
          "content-type": "application/json",
          Authorization: token,
        },
        withCredentials: true,
      };

      const response = await axios.request(config);
      if (response.status === 200) {
        setAmbassadorDelete(true);
        setLoading(null);
      }
    } catch (error) {
      console.log(error);
      setLoading(null);
    }
  };

  return (
    <>
      <Breadcrumb data="Ambassadors report" />
      <div className="content-body">
        <div className="table-data">
          <MaterialReactTable table={table} />
        </div>
      </div>
    </>
  );
}

export default AmbassadorsReport;
